"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.GET_EVENT_SERIES_DETAILS_URL = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _DrupalEventDate = _interopRequireDefault(require("./DrupalEventDate"));

var _DrupalRubric = _interopRequireDefault(require("./DrupalRubric.scss"));

var _ErvFront = _interopRequireDefault(require("./ErvFront"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _BuildConstants = require("../../../utils/BuildConstants");

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _DrupalRubricStrings = require("./DrupalRubricStrings");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DataStore = require("../../../KESI2/Stores/DataStore2");

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _Image = _interopRequireDefault(require("../Image/Image"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var GET_EVENT_SERIES_DETAILS_URL = 'rest/v1/course/_details';
exports.GET_EVENT_SERIES_DETAILS_URL = GET_EVENT_SERIES_DETAILS_URL;

var DrupalEventSeries = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalEventSeries, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalEventSeries);

  function DrupalEventSeries(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalEventSeries);
    _this = _super.call(this, props, context, props.contentPathArray[props.contentPathArray.length - 1]);
    /*
    KESI2BasicComponent also defines state, in order to keep DrupalLecture state
    and the already initialized Kesi2BasicComponent state we use ...this.state here.
    If we dont do that keys like "course" will be overridden to be null resulting in an app crash.
     */

    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeEventSeries", function () {
      _this.setState({
        expandedSingleEventSeries: null
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "downloadDocument", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(doc) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  if (_DeviceInfoHelper["default"].isBrowser()) {
                    window.open(doc.url, '_blank');
                  }
                } catch (error) {
                  console.log('openDocument', error);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.state = _objectSpread({
      eventDateStates: {}
    }, _this.state);
    _this.currentUpdateValue = props.updateValue;

    _this.setDataStorePaths([_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES]);

    return _this;
  }

  (0, _createClass2["default"])(DrupalEventSeries, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalEventSeries.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);

      if ((0, _stringify["default"])(prevProps.contentPathArray) !== (0, _stringify["default"])(this.props.contentPathArray) || this.props.updateValue !== this.currentUpdateValue) {
        this.currentUpdateValue = this.props.updateValue;
      }

      if (this.state.expandedSingleEventSeries && (0, _stringify["default"])(prevState.data[_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES]) !== (0, _stringify["default"])(this.state.data[_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES])) {
        // don't wait
        this.loadBookingState(this.state.expandedSingleEventSeries);
      }

      if (this.props.forceClose !== prevProps.forceClose) {
        // whenever the parent rubric is closed, this event series must be also closed for user convenience
        setTimeout(function () {
          _this2.closeEventSeries();
        }, 300);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.addEventListener('change', this.innerForceUpdate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalEventSeries.prototype), "componentWillUnmount", this).call(this);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.innerForceUpdate);
      }
    }
  }, {
    key: "getStyleForTile",
    value: function getStyleForTile() {
      var height = this.state.expandedSingleEventSeries ? 0 : _DrupalNestedTileSizes.TILE_SIZES.MEDIUM;
      return {
        container: {
          width: _DrupalNestedTileSizes.TILE_SIZES.MEDIUM,
          height: height,
          margin: _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES,
          zIndex: 0,
          opacity: 1,
          borderRadius: _cssConstants["default"].tiles && _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : ''
        },
        tile: {
          marginBottom: (_DrupalNestedTileSizes.LARGEST_TILE_SIZE - _DrupalNestedTileSizes.TILE_SIZES.LARGE) * this.state.zoomValue,
          opacity: this.state.expandedSingleEventSeries ? 0 : 1
        }
      };
    }
  }, {
    key: "getTileIdForContent",
    value: function getTileIdForContent(contentId) {
      return "eventseries-tile-".concat(contentId);
    }
    /**
     *
     * @param singleEventSeries {EventSeries}
     * @returns {Promise<void>}
     */

  }, {
    key: "loadBookingState",
    value: function () {
      var _loadBookingState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(singleEventSeries) {
        var tokenPromise, response, bookingState;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                tokenPromise = _RegisterInstance["default"].getAccessToken('course:read');
                _context2.t0 = _HttpRequest.httpGet;
                _context2.t1 = "".concat(_BuildConstants.SEMINARS_HOST, "/").concat(GET_EVENT_SERIES_DETAILS_URL);
                _context2.t2 = {
                  ids: singleEventSeries.uuid
                };
                _context2.next = 7;
                return tokenPromise;

              case 7:
                _context2.t3 = _context2.sent;
                _context2.t4 = 'Bearer ' + _context2.t3;
                _context2.next = 11;
                return (0, _context2.t0)(_context2.t1, _context2.t2, null, null, 10, _context2.t4);

              case 11:
                response = _context2.sent;
                console.log('booking state', response);

                if (response && response.data) {
                  bookingState = response.data; // let localBookingState = this.state.data[DATA_STORE_PATHS.BOOKED_EVENT_DATES] || []
                  // let localBookingStateChanged = false
                  //
                  // localBookingState.forEach(dateId => {
                  //   const content = KESI2Helper.getContentById(dateId)
                  //   const eventContent = KESI2Helper.getEventSeriesByEventDateId(dateId)
                  //   const uuidToFind = content.uuid
                  //
                  //   if (!bookingState[eventContent.uuid] || (bookingState[eventContent.uuid] && !bookingState[eventContent.uuid][uuidToFind])) {
                  //     localBookingState = removeElementFromCopy(localBookingState, dateId)
                  //     localBookingStateChanged = true
                  //   }
                  // })
                  //
                  // if (localBookingStateChanged) {
                  //   DataStore.setSingleData(DATA_STORE_PATHS.BOOKED_EVENT_DATES, localBookingState)
                  // }

                  if (bookingState[singleEventSeries.uuid]) {
                    this.setState({
                      eventDateStates: bookingState[singleEventSeries.uuid]
                    });
                  }
                }

                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t5 = _context2["catch"](0);
                console.error('error loading booking state from server', _context2.t5);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _DrupalRubricStrings.getString)('ERROR'),
                  message: (0, _ErrorHelper.getErrorMessage)(_context2.t5)
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 16]]);
      }));

      function loadBookingState(_x2) {
        return _loadBookingState.apply(this, arguments);
      }

      return loadBookingState;
    }()
  }, {
    key: "setOpen",
    value: function setOpen(singleEventSeries) {
      console.log('set open singleEventSeries', singleEventSeries);
      this.setState({
        expandedSingleEventSeries: singleEventSeries
      });
      this.loadBookingState(singleEventSeries);
    }
  }, {
    key: "renderEventDates",
    value: function renderEventDates() {
      var _this3 = this;

      var eventDatesRendered = (this.state.expandedSingleEventSeries ? this.state.expandedSingleEventSeries.eventDates : []).map(function (eventDateId) {
        var content = _KESI2Helper["default"].getContentById(eventDateId);

        if (!content) {
          return null;
        }

        var endDate = content.end;
        var endTimeStamp = new Date(endDate).getTime();
        var now = (0, _now["default"])();

        if (now > endTimeStamp) {
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement(_DrupalEventDate["default"], {
          key: eventDateId,
          eventDateId: eventDateId,
          eventDateStates: _this3.state.eventDateStates,
          onUpdate: function onUpdate() {
            return _this3.loadBookingState(_this3.state.expandedSingleEventSeries);
          }
        });
      });
      var title = this.state.expandedSingleEventSeries ? this.state.expandedSingleEventSeries.title : null;
      console.log('expandedSingleEventSeries', this.state.expandedSingleEventSeries);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_DrupalRubric["default"].eventDatesOuter, " ").concat(eventDatesRendered.length > 0 ? _DrupalRubric["default"].visible : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalRubric["default"].eventDates
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalRubric["default"].eventSeriesHeader
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _DrupalRubric["default"].eventSeriesTitle
      }, title), !this.state.expandedSingleEventSeries ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalRubric["default"].closeIcon,
        onClick: this.closeEventSeries
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "times"
      }))), this.state.expandedSingleEventSeries && this.state.expandedSingleEventSeries.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalRubric["default"].infoTextLeft,
        dangerouslySetInnerHTML: {
          __html: this.state.expandedSingleEventSeries.info
        }
      }) : null, this.state.expandedSingleEventSeries && this.state.expandedSingleEventSeries.documents ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalRubric["default"].fileContainer
      }, this.state.expandedSingleEventSeries.documents.map(function (document) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "document_".concat(document.name_to_show),
          className: _DrupalRubric["default"].singleFileContainer
        }, document.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].singleFileTitle
        }, document.title) : null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].singleFileHeader
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].singleFileName
        }, document.name_to_show), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: 'Download Icon',
          className: _DrupalRubric["default"].singleFileDownloadButton,
          src: _config["default"].downloadIcon,
          onClick: function onClick() {
            return _this3.downloadDocument(document);
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].singleFileInfo,
          dangerouslySetInnerHTML: {
            __html: document.info
          }
        }), /*#__PURE__*/_react["default"].createElement("hr", {
          className: _DrupalRubric["default"].singleFileDivider
        }));
      })) : null, eventDatesRendered));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var eventSeriesButtons = this.props.eventSeriesIds.map(function (singleEventSeriesId) {
        /**
         * @type EventSeries
         */
        var singleEventSeries = _KESI2Helper["default"].getContentById(singleEventSeriesId);

        if (!singleEventSeries || singleEventSeries.showPrecondition && (0, _PreconditionChecker.getFailingPrecondition)(singleEventSeries.showPrecondition) !== null) {
          return null;
        }

        var key = _this4.getTileIdForContent(singleEventSeriesId);

        var style = _this4.getStyleForTile();

        var myBookedEventDates = _this4.state.data[_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES] || [];
        var isBooked = singleEventSeries.eventDates.find(function (date) {
          return myBookedEventDates.indexOf(date) > -1;
        });
        console.log('DrupalEventSeries singleEventSeries', singleEventSeries, isBooked, myBookedEventDates);
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: "eventSeries_".concat(key),
          key: key,
          className: _DrupalRubric["default"].container,
          style: style.container
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: key,
          className: _DrupalRubric["default"].tile,
          onClick: function onClick() {
            _this4.setOpen(singleEventSeries);
          },
          style: style.tile
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].front,
          style: style.front
        }, /*#__PURE__*/_react["default"].createElement(_ErvFront["default"], {
          id: singleEventSeriesId,
          size: _DrupalNestedTileSizes.TILE_SIZES.MEDIUM,
          correctedSize: _DrupalNestedTileSizes.TILE_SIZES.MEDIUM,
          keywords: '',
          arrowColor: 'black',
          fontColor: singleEventSeries.fontColor ? singleEventSeries.fontColor : null,
          backgroundColor: singleEventSeries.backgroundColor ? singleEventSeries.backgroundColor : null,
          icon: singleEventSeries.icon,
          svgIcon: singleEventSeries.svgIcon,
          background: singleEventSeries.backgroundImage,
          isPublished: true,
          title: singleEventSeries.title,
          domId: key,
          useAsLink: true,
          expanded: false,
          animated: false,
          willBeOpened: false,
          closeTile: null,
          setBackButtonFunc: _this4.props.setBackButtonFunc,
          setTitle: _this4.props.setTitle,
          tileContentDidMount: null,
          setScrollBarHidden: _this4.props.setScrollBarHidden,
          setShowFavButton: _this4.props.setShowFavButton,
          isOnFirstLayer: false,
          outerCloseTile: null,
          outerDomId: key,
          colorClasses: null,
          updateFavFunc: _this4.getFavs,
          isBooked: Boolean(isBooked)
        }))));
      }); // <Button
      //   key={`eventseries_${singleEventSeriesId}`}
      //   variant="raised"
      //   onClick={() => this.setOpenOrCloseIfOpen(singleEventSeries)}
      // >
      //   {singleEventSeries.title}
      // </Button>

      var eventDates = this.renderEventDates();
      return /*#__PURE__*/_react["default"].createElement("div", null, eventDates, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalRubric["default"].eventSeriesTiles
      }, eventSeriesButtons));
    }
  }]);
  return DrupalEventSeries;
}(_KESI2BasicComponent["default"]);

DrupalEventSeries.propTypes = {
  eventSeriesIds: _propTypes["default"].array,
  contentPathArray: _propTypes["default"].array,
  forceClose: _propTypes["default"].bool
};
var _default = DrupalEventSeries;
exports["default"] = _default;